<template>
  <div>
    <div v-if="isNativeApp">
      <a class="button googleSignIn shortform-sign-up__button" @click="login">
        <img
          class="button__img"
          src="@/assets.app/images/sign-up-google.svg"
          alt=""
        />
        <span class="button__text d-none d-md-inline">Sign up with Google</span>
        <span class="button__text d-md-none">Sign up with Google</span>
      </a>
    </div>
    <div v-else>
      <!-- The following two divs are containers for the signup / signin
           with google buttons. The actual button HTML is rendered dynamically
           by googles GSI library. The function call to make that happen is
           in `GoogleAuthView.renderButtons`. The "big" and "small" divs
           exist because googles button rendering is non-responsive, so
           we create a desktop version and a mobile version. The CSS to
           display one or the other based on breakpoints is in
           src/assets.app/css/custom/_sign-up.scss
      -->
      <div
        v-if="showButton === 'all' || showButton === 'big'"
        id="sign-in-with-google-container-big"
        class="googleSigninBig"
      />
      <div
        v-if="showButton === 'all' || showButton === 'small'"
        id="sign-in-with-google-container-small"
        class="googleSigninSmall"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, onMounted, ref } from 'vue'

import { SocialAuthView } from '@/models/auth/social'
import { GoogleAuthView, AuthMode } from '@/models/auth/google'
import { GoogleNativeAuthView } from '@/models/auth/google.native'

const props = withDefaults(
  defineProps<{
    view: SocialAuthView
    authMode: AuthMode
    showButton?: 'small' | 'big' | 'all'
  }>(),
  {
    showButton: 'all',
  },
)

const isNativeApp = ref(false)

onBeforeMount(() => {
  isNativeApp.value = props.view instanceof GoogleNativeAuthView
})

onMounted(async () => {
  if (props.view instanceof GoogleAuthView) {
    await props.view.containerComponentHasMounted(props.authMode)
  }
})

async function login(): Promise<void> {
  if (props.view instanceof GoogleNativeAuthView) {
    await props.view.start()
  }
}
</script>
